module.exports = __webpack_public_path__ + "img/googlePlay.ed05a7dd.jpeg";